import { loadLazyImages } from "../utilities/globalUtilities";
import { initRecommendationsCarouselsSponsored } from "../recommendations/recommendationsUtil";
import { initializeCarousel } from "../productCarousel";
import { pushProductSponsoredImpression } from "../dataLayer/product";
import { filterRefinementCategories } from "../search/components/refinementUtils";
import { getAdstaxIDValue } from "./utils";
import { pushPageCustomAdvertising } from "../dataLayer/customAdvertising";
import { triggerInitWishlistTogglers } from "../wishlist/wishlist";
import productQtyMap from "../utilities/ProductQtyMap";
const PROMO_VIEW = "promoView";
const PROMO_CLICK = "promoClick";
const $cache = {
    body: $("body")
};
let carouselIdentifier = ".bannercarousel-container";

$(document).ready(function () {
    const observerOptions = { threshold: [0.1] };
    const trackedElements = new Set();
    const trackedElementsView = new Set();
    const intersectionObserver = new IntersectionObserver(handleIntersection, observerOptions);
    const mutationObserver = new MutationObserver(handleMutation);

    if ($(".dynamic-bannercarousel-container").length > 0)
        carouselIdentifier = ".dynamic-bannercarousel-container";

    let isNewTab = false;

    $cache.body.on("click", "a.pwc-tile--description, .track-click .ct-tile-image, .track-click .ct-pdp-details, .js-add-to-cart, .banner-click, .wishlist-toggler.inactive", handleClick);
    $cache.body.on("mousedown", "a.pwc-tile--description, .track-click .ct-tile-image, .track-click .ct-pdp-details, .js-add-to-cart, .banner-click, .wishlist-toggler.inactive", handleMouseDown);
    $cache.body.on("mouseup", "a.pwc-tile--description, .track-click .ct-tile-image, .track-click .ct-pdp-details, .js-add-to-cart, .banner-click, .wishlist-toggler.inactive", handleMouseUp);
    mutationObserver.observe(document.body, { childList: true, subtree: true });
    $(".experience-commerce_layouts-bannerCarousel").on("beforeChange afterChange", handleCarouselChange);

    function handleMouseDown(e) {
        if (e.which === 2  || e.ctrlKey || e.metaKey) {
            isNewTab = true;
        } else if (e.which === 3) {
            handleClick.call(this, e, true, false);
        } else {
            isNewTab = false;
        }
    }

    function handleMouseUp(e) {
        if (isNewTab && (e.which === 2 || e.ctrlKey || e.metaKey)) {
            handleClick.call(this, e, true);
        }
    }

    function handleClick(e, isNewTab = false, navigateToUrl = true) {
        if (!isNewTab) {
            e.preventDefault();
        }
        const $trackClickElement = $(this).closest(".track-click");
        const clickUrl = $(this).data("click-url") || $trackClickElement.data("click-url");
        const trackUrl = $trackClickElement.data("track-url");
        const isBannerClick = $(this).hasClass("banner-click");
        const imgAdvertised = $(this).find("img").attr("src");

        const navigate = (url) => {
            if (!isNewTab) {
                window.location.href = url;
            } else if (navigateToUrl) {
                window.open(url, "_blank");
            }
        };

        const timeoutPromise = new Promise((resolve) => setTimeout(resolve, 1000));

        if (isBannerClick) {
            pushPromosData($(this), imgAdvertised, PROMO_CLICK);
            if (imgAdvertised) {
                const hrefBanner = $(this)[0].href;
                if (hrefBanner) {
                    const clickTrack = $trackClickElement.data("click-track");
                    if (clickTrack) {
                        Promise.race([sendTrackingClick(clickTrack, trackUrl), timeoutPromise])
                            .finally(() => { if (navigateToUrl) { navigate(hrefBanner); } });
                    } else {
                        navigate(hrefBanner);
                    }
                }
            }
        } else {
            if (trackUrl && clickUrl) {
                Promise.race([sendTrackingClick(clickUrl, trackUrl), timeoutPromise])
                    .finally();
            }
        }
    }

    function handleIntersection(entries) {
        entries.forEach(entry => {
            if (entry.isIntersecting && !trackedElements.has(entry.target)) {
                const $element = $(entry.target);
                const impressionUrl = $element.data("impression-view-url");
                const trackUrl = $element.data("track-url");
                if (!impressionUrl || trackedElementsView.has(impressionUrl)) return;
                trackedElements.add(entry.target);
                trackedElementsView.add(impressionUrl);

                if ($element.hasClass("product-tile-loaded-sponsored")) {
                    pushProductSponsoredImpression();
                } else {
                    const imgAdvertised = $element.find("img").attr("src");
                    pushPromosData($element, imgAdvertised, PROMO_VIEW);
                }

                sendTracking(impressionUrl, trackUrl);
            }
        });
    }

    function sendTrackingClick(trackingUrl, trackUrl) {
        if (trackingUrl && trackUrl) {
            return fetch(trackUrl, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({
                    encryptedUrls: trackingUrl
                })
            }).catch(_ => Promise.resolve());
        }
        return Promise.resolve();
    }

    function sendTracking(trackingUrl, trackUrl) {
        if (trackingUrl && trackUrl) {
            $.ajax({
                url: trackUrl,
                method: "POST",
                contentType: "application/json",
                data: JSON.stringify({
                    encryptedUrls: trackingUrl
                })
            });
        }
    }

    function handleMutation(mutations) {
        mutations.forEach(mutation => {
            mutation.addedNodes.forEach(node => {
                if (node.nodeType === 1) {
                    if ($(node).hasClass("track-click")) {
                        if (!trackedElementsView.has(node)) {
                            sendTracking($(node).data("impression-url"), $(node).data("track-url"));
                            trackedElementsView.add($(node).data("impression-url"));
                        }
                        intersectionObserver.observe(node);
                    } else {
                        const trackClickElement = $(node).find(".track-click");
                        if (trackClickElement.length > 0) {
                            trackClickElement.each(function () {
                                const element = this;
                                if (!trackedElementsView.has($(element).data("impression-url"))) {
                                    sendTracking($(element).data("impression-url"), $(element).data("track-url"));
                                    trackedElementsView.add($(element).data("impression-url"));
                                }
                                intersectionObserver.observe(element);
                            });
                        }
                    }
                }
            });
        });
    }

    function handleCarouselChange(event, slick, currentSlide) {
        var $currentSlideElement = $(slick.$slides[currentSlide]);
        var $trackClickLink = $currentSlideElement.find(".track-click");

        if ($trackClickLink.length) {
            var domElem = $trackClickLink.get(0);
            var impressionViewUrl = $trackClickLink.data("impression-url");
            if (!trackedElementsView.has(impressionViewUrl)) {
                sendTracking(impressionViewUrl, $trackClickLink.data("track-url"));
                trackedElementsView.add(impressionViewUrl);
            }
            intersectionObserver.observe(domElem);
        }
    }

    function pushPromosData($element, imgAdvertised, eventType) {
        pushPageCustomAdvertising({
            idAdvertised: $element.data("advertiser-id"),
            campaignId: $element.data("campaign-id"),
            flightId: $element.data("flight-id"),
            priorityId: $element.data("priority-id"),
            adId: $element.data("ad-id"),
            imgAdvertised
        }, eventType);
    }
});

function isActuallyVisible(element) {
    const $element = $(element);

    return $element.is(":visible") && !$element.closest(".hidden-container").length;
}

function getDeviceType() {
    const { mobile, tablet, desktop, desktopLarge } = window.mqRespond.status;

    if (mobile) {
        return "mobile";
    }

    if (tablet) {
        return "tablet";
    }

    if (desktop || desktopLarge) {
        return "desktop";
    }

    return null;
}

function fetchAdData() {
    var adsData = [];
    var wrappers = $(".content-container-wrapper:not(.processed)");
    let searchTerm = $("input.search-field").val();

    var adstaxUid = getAdstaxIDValue();
    wrappers.each(function () {
        var wrapper = $(this);
        var innerDiv = wrapper.find("div.gpt-contents").first();

        if (wrapper.hasClass("postpone-load") && !isActuallyVisible(wrapper[0])) {
            return;
        }

        if (!innerDiv.length) {
            return;
        }

        var dataUrl = wrapper.data("url");
        if (!dataUrl) {
            return;
        }

        var categoryId = innerDiv.data("category-id") || wrapper.data("category-id");
        var consentMarketing = false;

        if (window.Cookiebot && window.Cookiebot.consent) {
            consentMarketing = window.Cookiebot.consent.marketing;
        }

        var category = filterRefinementCategories(categoryId, true);
        var zoneId = wrapper.data("zone-id") || wrapper.data("ad-zone-id") || innerDiv.data("zone-id") || innerDiv.data("ad-zone-id") || null;

        adsData.push({
            adTypeName: innerDiv.data("ad-type-name"),
            adTypeIds: innerDiv.data("ad-type-ids"),
            kevelBannerLevelKeyword: innerDiv.data("ad-kevel-keyword"),
            adZoneId: zoneId,
            categoryId: category ? category.firstLevelCategory : categoryId ? categoryId : "",
            categoryPath: category ? category.categoryPathFull : categoryId ? categoryId : "",
            productPageId: categoryId,
            adstaxUid: adstaxUid,
            searchTerm: searchTerm,
            dataUrl: dataUrl,
            gdprValue: consentMarketing,
            kevelCategoryKeyword: innerDiv.data("kevel-keyword"),
            deviceType: getDeviceType()
        });

        wrapper.addClass("processed");
    });

    if (!adsData.length) {
        return;
    }

    var endpointUrl = adsData[0].dataUrl;
    sendAjaxRequest(endpointUrl, adsData);
}

function fetchASponsoredData(wrapperClass, isCarousel) {
    var adsData = [];
    var wrappers = $(`${wrapperClass}:not(.processed)`);
    var url;

    if (!wrappers.length) return;

    wrappers.each(function () {
        var wrapper = $(this);
        if (!wrapper.length) return;

        var dataUrl = wrapper.data("url");
        if (!dataUrl) return;

        url = dataUrl;

        var consentMarketing = false;
        const isRecommendationPage = $(".ct-recommendations--product-carousels").length > 0;

        if (window.Cookiebot && window.Cookiebot.consent) {
            consentMarketing = window.Cookiebot.consent.marketing;
        }

        var productIdsDiv = $(".ids-for-sponsored-products");
        var zoneId = wrapper.data("zone-id") || wrapper.data("adzone-id") || null;
        var adstaxUid = getAdstaxIDValue();
        var categoryId = wrapper.data("category-id");
        var category = filterRefinementCategories(categoryId, true);

        const typeName = wrappers.length > 1 ? zoneId : "product_sponsored";

        adsData.push({
            adTypeName: isCarousel ? typeName : wrapper.data("ad-type-name"),
            adTypeIds: wrapper.data("ad-type-ids"),
            categoryId: category ? category.firstLevelCategory : categoryId ? categoryId : "",
            categoryPath: category ? category.categoryPathFull : categoryId ? categoryId : "",
            productPageId: categoryId,
            adZoneId: zoneId,
            productIds: wrapper.data("product-ids"),
            adstaxUid: adstaxUid,
            dataUrl: dataUrl,
            isCarousel: isCarousel,
            searchTerm: $("input.search-field").val(),
            productIdsForSponsored: productIdsDiv.length ? productIdsDiv.data("ids-for-sponsored-products") : "",
            numberSponsoredProducts: !isNaN(wrapper.data("number-sponsored")) ? wrapper.data("number-sponsored") : 4,
            gdprValue: consentMarketing,
            isRecommendationsPage: isRecommendationPage
        });

        wrapper.addClass("processed");
    });

    if (!url) return;

    $.ajax({
        url: url,
        type: "POST",
        dataType: "JSON",
        data: { adsData: JSON.stringify(adsData) },
        success: function (data) {
            let initCarrousel = false;
            wrappers.each(function (index) {
                var wrapper = $(this);
                if (!wrapper.length) return;

                var zoneId = wrapper.data("adzoneId");
                if (data.success && data.htmlArray && data.htmlArray.length > 0) {
                    var aggregatedHTML = "";
                    let sponsoredProductCount = data.htmlArray.length;
                    data.htmlArray.forEach(function (productHtmlObj) {
                        if (wrappers.length > 1 && productHtmlObj.zoneId != zoneId) {
                            return;
                        }
                        if (productHtmlObj.html.trim() !== "") {
                            const divId = productHtmlObj.divId;
                            const adTrackingDoubleVerifyTag = productHtmlObj.adTrackingDoubleVerifyTag || "";
                            const cleanAdTrackingDoubleVerifyTag = adTrackingDoubleVerifyTag.replace(/^"|"$/g, "").replace(/&quot;/g, "\"").replace(/""/g, "\"");

                            var additionalAttributes = productHtmlObj.isAdvertised ?
                                " data-click-url=\"" + productHtmlObj.clickUrl + "\"" +
                                " data-track-url=\"" + productHtmlObj.trackUrl + "\"" +
                                " data-impression-view-url=\"" + productHtmlObj.impressionViewUrl + "\"" +
                                " data-impression-url=\"" + productHtmlObj.impressionUrl + "\"" : "";

                            var wrappedProductTile = "<div id=\"" + divId + "\" class=\"" + (isCarousel ? "pd-tile-wrap product-tile-loaded-sponsored" : "col-12 col-sm-3 col-lg-2 productTile product product-tile-loaded-sponsored") +
                                (productHtmlObj.isAdvertised ? " track-click" : "") + "\"" +
                                additionalAttributes + ">" +
                                (isCarousel ? ("<div class=\"product\" data-pid=\"" + productHtmlObj.pid + "\">" + productHtmlObj.html + "</div>") : productHtmlObj.html) +
                                cleanAdTrackingDoubleVerifyTag + "</div>";
                            aggregatedHTML += wrappedProductTile;
                        }
                    });

                    if (isCarousel && aggregatedHTML.trim() !== "") {
                        if (wrapper.data("is-recommendation")) {
                            if (!$(".recommendations-products-carousel-sponsored").eq(index).hasClass("slick-initialized")) {
                                $(".recommendations-products-carousel-sponsored").html(aggregatedHTML);
                                initRecommendationsCarouselsSponsored();
                            }

                            loadLazyImages();
                        } else {
                            wrapper.closest(".experience-commerce_assets-productTilesSponsored").html(aggregatedHTML);
                            initCarrousel = true;
                        }

                        if ($(".product-tile").length > 0 && parseInt($(".minicart .minicart-quantity").text(), 10) !== 0) {
                            $cache.body.trigger("product:syncTileData", productQtyMap);
                        }
                    } else if (!isCarousel && aggregatedHTML.trim() !== "") {
                        handleSponsoredProductsGridDisplay(aggregatedHTML, sponsoredProductCount);
                        triggerInitWishlistTogglers();

                        if ($(".product-tile").length > 0 && parseInt($(".minicart .minicart-quantity").text(), 10) !== 0) {
                            $cache.body.trigger("product:syncTileData", productQtyMap);
                        }

                        loadLazyImages();
                    }
                } else {
                    wrapper.addClass("d-none").closest(".pwc-subtitle").addClass("d-none");

                    const $pdSponsoredProductsGridWrapper = $(".js-pd-sponsored-product-grid-wrapper");
                    if ($pdSponsoredProductsGridWrapper.length > 0) {
                        $pdSponsoredProductsGridWrapper.hide();
                    }
                }
            });

            if (initCarrousel) {
                initializeCarousel(".experience-commerce_assets-productTilesSponsored");
                loadLazyImages();
            }

            triggerInitWishlistTogglers();
        },
        error: function () {
            wrappers.each(function () {
                var wrapper = $(this);
                wrapper?.addClass("d-none").closest(".pwc-subtitle").addClass("d-none");
            });
            console.error("Failed to fetch ads data.");
        }
    });
}

/**
* Handles the display of sponsored products within the Page Designer Product Grid Sponsored component.
*/
function handleSponsoredProductsGridDisplay(aggregatedHTML, sponsoredProductCount) {
    // Logic for the sponsored products to be displayed on the Page Designer Product Grid component.
    const $pdProductGrid = $(".js-pd-product-grid");
    const $productGrid = $pdProductGrid.length === 0 ? $(".product-grid") : $pdProductGrid.find(".js-pd-product-grid-row");
    $productGrid?.prepend(aggregatedHTML);

    // Determine the count of sponsored products
    const $sponsoredProducts = $(".product-tile-loaded-sponsored");
    const threshold = 36; // Mirrors PLP product tile count logic.
    let totalCount = 0;

    // Show the load more button if the sponsored product count exceeds the threshold.
    const $loadMoreButton = $(".js-load-more-products");
    if (sponsoredProductCount > threshold) {
        $sponsoredProducts.slice(threshold).addClass("d-none");
        $loadMoreButton.removeClass("d-none");
    } else {
        $loadMoreButton.addClass("d-none");
    }

    // Update the product count message.
    let $pdProductGridCounter = $(".js-pd-product-grid-counter");
    if ($pdProductGridCounter.length > 0) {
        let currentCount = threshold < sponsoredProductCount ? threshold : sponsoredProductCount;
        totalCount = parseInt($pdProductGrid.data("total-count"), 10);
        updateProductGridSponsoredCountMessage($pdProductGridCounter, currentCount, totalCount, sponsoredProductCount);
    }

    // Load more button click event
    if ($loadMoreButton && $pdProductGrid) {
        $loadMoreButton.on("click", () => {
            // Show the next set of sponsored products
            const $hiddenSponsoredProducts = $sponsoredProducts.filter(".d-none");
            $hiddenSponsoredProducts.removeClass("d-none");

            // Updates the sponsored product count.
            const currentCount = $pdProductGrid.find(".product-tile-loaded-sponsored:not(.d-none)").length;
            if ($pdProductGridCounter) {
                updateProductGridSponsoredCountMessage($pdProductGridCounter, currentCount, totalCount, sponsoredProductCount);
            }

            // Hides the button if all sponsored products are shown.
            if (currentCount >= totalCount + sponsoredProductCount) {
                $loadMoreButton.hide();
            }
        });
    }
}

/**
* Updates the product grid counter message to include the count of sponsored products.
*/
function updateProductGridSponsoredCountMessage($pdProductGridCounter, currentCount, totalCount, sponsoredProductCount) {
    let gridCountMessage = `${currentCount} de ${totalCount + sponsoredProductCount} produtos`;
    $pdProductGridCounter.text(gridCountMessage);
}

function sendAjaxRequest(endpointUrl, adsData) { 
    const adTypesList = adsData.reduce((acc, item) => {
        acc[item.adTypeName] = (acc[item.adTypeName] || 0) + 1;
        return acc;
    }, {});
  
    $.ajax({
        url: endpointUrl,
        type: "POST",
        dataType: "JSON",
        data: {
            adsData: JSON.stringify(adsData)
        },
        success: function (data) {
            clearEmptyAdvertisimentBanners(data, adTypesList);
            handleAjaxSuccess(data);
        },
        error: function () {
            clearEmptyAdvertisimentBanners({content: []}, adTypesList);
            console.error("Failed to fetch ads data.");
        }
    });
}

// Remove extra divs if there are more than the number of ads returned.
function clearEmptyAdvertisimentBanners(data, adTypesList) {
    for (const key in adTypesList) {
        let contentDataArray = [];
        if (data.content && data.content[key]) {
            contentDataArray = Array.isArray(data.content[key]) ? data.content[key] : [data.content[key]];
        }
        const targetDivs = $(".content-container-wrapper div.gpt-contents[data-ad-type-name='" + key + "']");

        // Remove extra divs if there are more than the number of ads returned.
        if (targetDivs.length > contentDataArray.length) {
            const diff = targetDivs.length - contentDataArray.length;
            for (let i = targetDivs.length - 1; i >= targetDivs.length - diff; i--) {
                targetDivs[i].closest(".experience-commerce_assets-advertisementBanner")?.remove();
            }
        }
    }
}

function handleAjaxSuccess(data) {
    if (data.success && data.content) {
        // Global flag to aid in carousel initialization, preventing it from loading before the Kevel Data is fetched, if time is less than x ms.
        // This flag is used in the bannerCarousel.js file.
        window.kevelAdsAjaxDataLoaded = true;

        let bannerCarouselData = false;
        for (const key in data.content) {
            const contentDataArray = Array.isArray(data.content[key]) ? data.content[key] : data.content[key] ? [data.content[key]] : [];
            const targetDivs = $(".content-container-wrapper div.gpt-contents[data-ad-type-name='" + key + "']");

            contentDataArray.forEach((contentData, index) => {
                const targetDiv = targetDivs.eq(index);
                if (!targetDiv.length) return;

                const bannercarouselContainer = targetDiv.closest(carouselIdentifier);
                if (bannercarouselContainer.length > 0) {
                    if (!contentData.body || !contentData.imageUrl) {
                        return;
                    }
                    bannerCarouselData = true;
                    const hrefBanner = $(contentData.body).attr("href") || "#";
                    const imageUrl = contentData.imageUrl;
                    const adTrackingDoubleVerifyTag = contentData.adTrackingDoubleVerifyTag || "";
                    const cleanAdTrackingDoubleVerifyTag = adTrackingDoubleVerifyTag.replace(/^"|"$/g, "").replace(/&quot;/g, "\"").replace(/""/g, "\"");
                    const divId = contentData.divId;
                    const html = `<div id="${divId}"> 
                        <div class="mainbanner-container false">
                            <div class="row no-margin">
                                <div class="col-12 no-padding--sides">
                                    <figure class="mainbanner-figure image-component">
                                        <a href="${hrefBanner}" tabindex="-1">
                                            <div class="mainbanner-image common-image-component">
                                                <picture class="intrinsic intrinsic--hero-banner">
                                                    <source srcset="${imageUrl}" media="(min-width: 1920.0px)">
                                                    <source srcset="${imageUrl}" media="(min-width: 1280.0px)">
                                                    <source srcset="${imageUrl}" media="(min-width: 768.0px)">
                                                    <source srcset="${imageUrl}" media="(min-width: 320.0px)">
                                                    <img src="${imageUrl}" alt="HeroBanner Ads">
                                                </picture>
                                            </div>
                                        </a>
                                        ${cleanAdTrackingDoubleVerifyTag}
                                    </figure>
                                </div>
                            </div>
                        </div>
                    </div>`;

                    targetDiv.html(html);

                    const adBanner = bannercarouselContainer.find(".experience-commerce_assets-advertisementBanner");
                    adBanner.addClass("slick-slide");
                    adBanner.removeClass("d-none");

                    const wrapperDiv = targetDiv.closest(".third-party-content-container-wrapper");
                    wrapperDiv.removeClass("third-party-content-container-wrapper");
                } else {
                    const adTrackingDoubleVerifyTag = contentData.adTrackingDoubleVerifyTag || "";
                    const cleanAdTrackingDoubleVerifyTag = adTrackingDoubleVerifyTag.replace(/^"|"$/g, "").replace(/&quot;/g, "\"").replace(/""/g, "\"");
                    const divId = contentData.divId;
                    var divBanner = "<div id=\"" + divId + "\">" + contentData.body + cleanAdTrackingDoubleVerifyTag + "</div>";
                    targetDiv.html(divBanner);
                }

                const kevelNameLabel = targetDiv.closest(".content-container-wrapper").find(".kevelad-label");
                if (kevelNameLabel && contentData.name) {
                    kevelNameLabel.text(contentData.name);
                }

                const anchorTag = targetDiv.find("a");
                anchorTag.attr({
                    "data-impression-url": contentData.impressionUrl,
                    "data-impression-view-url": contentData.impressionViewUrl,
                    "data-track-url": contentData.trackUrl,
                    "data-advertiser-id": contentData.advertiserId,
                    "data-campaign-id": contentData.campaignId,
                    "data-flight-id": contentData.flightId,
                    "data-priority-id": contentData.priorityId,
                    "data-click-track": contentData.clicktrack,
                    "data-ad-id": contentData.adId
                });

                anchorTag.addClass("track-click");
                anchorTag.addClass("banner-click");
            });

            $(".content-container-wrapper").removeClass("d-none");
            if (bannerCarouselData) {
                if ($(".experience-slides").hasClass("slick-initialized")) {
                    $(".experience-slides").slick("setPosition");
                }
                let attempts = 0;
                let delay = 100;
                const checkAndTryRefresh = function () {
                    if (attempts >= 10) return;
                    const banners = $(".experience-component .experience-commerce_assets-advertisementBanner:not(.slick-initialized)");
                    const filteredBanners = banners.filter(function () {
                        return $(this).closest(carouselIdentifier).length;
                    });
                    if (filteredBanners && filteredBanners.length) {
                        filteredBanners.addClass("slick-slide").removeClass("d-none slick-current slick-active");
                        if ($(".experience-slides").hasClass("slick-initialized")) {
                            $(".experience-slides").slick("refresh");
                            return;
                        }
                    }
                    attempts++;
                    delay += 100;
                    setTimeout(checkAndTryRefresh, delay);
                };
                setTimeout(checkAndTryRefresh, delay);
            }
        }
    }
}

$(".experience-slides").on("init", function () {
    $(".experience-commerce_assets-advertisementBanner.slick-slide").addClass("d-none").removeClass("slick-slide");
});

window.onload = function () {
    if ($(".experience-slides").hasClass("slick-initialized")) {
        $(".experience-slides").slick("refresh");
    }
};

var observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
        if (!mutation.addedNodes.length) return;

        var isNewNodeAdvertisingWrapper = Array.from(mutation.addedNodes).some(node => {
            return $(node).hasClass("content-container-wrapper") || $(node).find(".content-container-wrapper").length;
        });

        if (isNewNodeAdvertisingWrapper) fetchAdData();
    });
});

observer.observe(document.body, {
    childList: true,
    subtree: true
});

function init() {
    fetchASponsoredData(".content-container-wrapper-sponsored", false);
    fetchASponsoredData(".product-tiles-products", true);
    fetchAdData();
}

module.exports = {
    init: init
};
